import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigQuestion } from '../../models/config-question.interface';
import {
	ControlValueAccessor,
	UntypedFormControl,
	UntypedFormGroup,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Moment } from 'moment';
import { ErrorMessage } from '../../constants/enum.const';

@Component({
	selector: 'bcb-generic-date',
	templateUrl: './generic-date.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: GenericDateComponent,
		},
	],
	styleUrls: ['./generic-date.component.scss'],
})
export class GenericDateComponent implements ControlValueAccessor, OnInit {
	@Input() question!: ConfigQuestion;
	@Input() formGroup?: UntypedFormGroup;
	@Input() formControl?: UntypedFormControl;
	@Input() formControlName!: string;
	@Input() errorMessage?: ErrorMessage;
	@Output() change: EventEmitter<any> = new EventEmitter<any>();

	value: any;
	isDisabled: boolean = false;

	constructor() {}

	ngOnInit(): void {
		if (this.formControl) {
			this.formGroup = this.formControl.parent as UntypedFormGroup;
		} else if (this.formGroup && this.formControlName) {
			this.formControl = this.formGroup.get(
				this.formControlName
			) as UntypedFormControl;
		} else {
			throw new Error(
				'One of the following is required: [formControl] or [formControlName] + [FormGroup]'
			);
		}
	}

	changed: (value: any) => void = () => {};

	touched: () => void = () => {};

	writeValue(obj: any): void {
		this.value = obj;
	}

	onChange(event: MatDatepickerInputEvent<Moment>): void {
		const iso = event.value?.toISOString();
		this.changed(iso);
		this.change.emit(iso);
	}

	registerOnChange(fn: any): void {
		this.changed = fn;
	}

	registerOnTouched(fn: any): void {
		this.touched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}
}
